import { Location } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { LayoutService } from "../../../@core/utils";

@Component({
    selector: "ngx-back-button",
    template: `
         <button *ngIf="useHeader" nbButton ghost status="basic" (click)="back()"><nb-icon icon="close-outline"></nb-icon></button>
    `,
    encapsulation: ViewEncapsulation.None,
})
export class BackButton implements OnInit {

    @Input("useEvent") public useEvent: boolean = true;
    @Output("back") public backEvent: EventEmitter<any> = new EventEmitter<any>();

    constructor(private layoutService: LayoutService, private location: Location) { }

    ngOnInit() {
    }

    back() {
        if (this.useEvent){
            this.backEvent.emit();
        } else {
            this.location.back();
        }
    }

    public get useHeader(): boolean {
        return this.layoutService.useHeader;
    }
}
